/* eslint-disable react/destructuring-assignment */
import { Event, ContactMail, Groups, Schedule, PriorityHigh, Public, Check } from '@mui/icons-material';
import { Badge, StepIconProps } from '@mui/material';
import { StyledMultiStepIconRoot } from './styledMultiStepIconRoot';
import { Colors } from '../styles/colors';

export function MultiStepIcon(props: StepIconProps & { isDisabled: boolean; isComplete: boolean | null; showComplete?: boolean }) {
  const { active, completed, className, isDisabled, isComplete, showComplete } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <Public />,
    2: <Event />,
    3: <Schedule />,
    4: <Groups />,
    5: <ContactMail />,
  };

  // Grön check när steget är klart (endast om showComplete), gul varning när något saknas.
  const showCheck = !!showComplete && isComplete === true;
  const showWarning = isComplete === false;

  const BadgeWrapper = ({ children }) => {
    const arrowWidth = 8; // px
    return (
      <Badge
        sx={{
          '& .MuiBadge-badge': {
            borderRadius: '100%',
            height: '25px',
          },
          '& .badgeicon': {
            fontSize: '0.8rem',
          },
          ...(active && {
            '&:after': {
              position: 'absolute',
              pointerEvents: 'none',
              content: '" "',
              top: 'calc(100%)',
              left: `calc(50% - ${arrowWidth}px)`,
              width: 0,
              height: 0,
              borderStyle: 'solid',
              borderRight: `${arrowWidth}px solid transparent`,
              borderLeft: `${arrowWidth}px solid transparent`,
              borderTop: `10px solid ${Colors.Blue}`,
              borderBottom: 0,
            },
          }),
        }}
        color={showCheck ? 'success' : 'warning'}
        badgeContent={showCheck ? <Check className='badgeicon' /> : <PriorityHigh className='badgeicon' />}
        invisible={!(showCheck || showWarning)}
      >
        {children}
      </Badge>
    );
  };

  return (
    <BadgeWrapper>
      <StyledMultiStepIconRoot ownerState={{ completed, active }} className={className} isDisabled={isDisabled}>
        {icons[String(props.icon)]}
      </StyledMultiStepIconRoot>
    </BadgeWrapper>
  );
}
